import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SubCategorys from "../Components/SubCategory/SubCategorys";

function SubCategory() {
    const [comp, setComp] = useState("list");
    const [rowData, setRowData] = useState();
    const location = useLocation();
  
    useEffect(() => {
      setComp("list");
    }, [location]);
  
    function handleChange(newValue) {
      setComp(newValue.mode);
      setRowData(newValue.rowData);
    }
    return <><SubCategorys/></>;
}

export default SubCategory